import { ArrowRight, Target, CheckCircle2 } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Button } from "@/components/ui/Button";
import { Reveal } from "@/components/common/Reveal";
import { BeforeAfter } from "@/components/common/BeforeAfter";
import { useScrollTo } from "@/hooks/useScrollTo";
import { SPOTLIGHT } from "@/utils/constants";

export const ProjectSpotlight = () => {
  const scrollTo = useScrollTo();

  return (
    <Section id="spotlight" testId="spotlight-section" bg="ink" blueprint blueprintOpacity={0.15} containerClassName="grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-3 bg-weld/10 blur-2xl rounded-3xl" />
          <BeforeAfter
            before={SPOTLIGHT.before}
            after={SPOTLIGHT.after}
            altBefore={`${SPOTLIGHT.title} — before repair`}
            altAfter={`${SPOTLIGHT.title} — after repair`}
            className="relative clip-frame border border-weld/20"
          />
        </div>
      </Reveal>

      <Reveal delay={0.12}>
        <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">{SPOTLIGHT.eyebrow}</p>
        <h2 className="font-display text-5xl md:text-6xl text-white leading-none">{SPOTLIGHT.title}</h2>
        <p className="text-white/65 mt-5 leading-relaxed">{SPOTLIGHT.description}</p>

        <div className="mt-6 flex items-start gap-3">
          <Target className="text-weld-glow shrink-0 mt-1" size={20} />
          <p className="text-white/70"><span className="text-white font-semibold">Problem solved: </span>{SPOTLIGHT.problem}</p>
        </div>

        <ul className="mt-6 grid sm:grid-cols-2 gap-3">
          {SPOTLIGHT.details.map((d) => (
            <li key={d} className="flex items-start gap-2 text-white/70 text-sm">
              <CheckCircle2 className="text-weld shrink-0 mt-0.5" size={16} /> {d}
            </li>
          ))}
        </ul>

        <Button data-testid="spotlight-cta" size="lg" className="mt-8" onClick={() => scrollTo("contact")}>
          Start Your Project <ArrowRight size={18} />
        </Button>
      </Reveal>
    </Section>
  );
};
